//Home.js
import React, { useState, useEffect } from "react";
import Navbar from "../components/MainNavbar";

// Require Editor CSS files.
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";

import FroalaEditorComponent from "react-froala-wysiwyg";
import SongsNavbar from "../components/SongsNavBar";

import { TSongSheet } from "../types/SongSheet";
import { useParams } from "react-router-dom";
import { GetSongSheetById, UpdateSongSheet } from "../services/SongSheet";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import TagInput from "../components/TagInput";
import { Tag } from "react-tag-input/types/components/SingleTag";
import DropdownList from "../components/UI/Dropdown";

const EditSongSheet = () => {
  let { id } = useParams();

  const [songId, setSongId] = useState(id);
  const [songName, setSongName] = useState("");
  const [artist, setArtist] = useState("");
  const [lyrics, setLyrics] = useState("");
  const [chords, setChords] = useState("");
  const [songType, setSongType] = useState("Cover");
  const [capo, setCapo] = useState("");
  const [defaultFontSize, setDefaultFontSize] = useState(16);
  const [tags, setTags] = React.useState<Array<Tag>>([]);
  const [folder, setFolder] = React.useState("");

  const handleUpdateTags = (tags: any) => {
    console.log("*** tags updated ***", tags);
    setTags(tags);
  };

  const folderOptions = [
    { value: "ready", label: "Gig Ready" },
    { value: "wip", label: "WIP" },
    { value: "ideas", label: "Ideas" },
    { value: "archive", label: "Archive" },
  ];

  const haandleFolderChanged = (newFolder: any) => {
    console.log("Set folder to ", newFolder);
    setFolder(newFolder);
  };

  const performUpdateSongSheet = () => {
    const newSong = {
      _id: songId,
      name: songName,
      capo: capo,
      artist: artist,
      lyrics: lyrics,
      chords: chords,
      songType: songType,
      defaultFontSize: defaultFontSize,
      tags: tags,
      folder: folder,
    };

    UpdateSongSheet(
      songId,
      newSong,
      (res: any) => {
        console.log(res);
        toast.success("Song Sheet was updated!");
      },
      (err: any) => {
        console.log(err);
        toast.error("An error occured updating the song sheet");
      }
    );
  };

  const handleSubmit = (e: any) => {
    performUpdateSongSheet();
    e.preventDefault();
  };

  const loadSongSheetData = (songSheet: TSongSheet) => {
    setSongId(songSheet._id);
    setSongName(songSheet.name);
    setArtist(songSheet.artist);
    setCapo(songSheet.capo);
    setChords(songSheet.chords);
    setLyrics(songSheet.lyrics);
    setSongType(songSheet.songType);
    setDefaultFontSize(songSheet.defaultFontSize);
    setTags(songSheet.tags || []);
    setFolder(songSheet.folder);
  };

  useEffect(() => {
    if (id) {
      GetSongSheetById(
        id,
        (res: any) => {
          //success
          loadSongSheetData(res.data.songSheet);
        },
        (err: any) => {
          //error
          alert(err);
        }
      );
    }
  }, []);

  return (
    <div>
      <Navbar />
      <SongsNavbar />
      <div className="mainContainer">
        <h1>Edit Song Sheet</h1>

        <div className="editorWrapper">
          <form
            onSubmit={(e) => {
              handleSubmit(e);
            }}
          >
            <div className="two-columns-container">
              <div className="column-left">
                <span className="form-field">
                  <label htmlFor="lname">Song Name</label>
                  <input
                    id="songname"
                    type="text"
                    placeholder="Song Name"
                    value={songName}
                    onChange={(e) => setSongName(e.target.value)}
                  />
                </span>
                <br />

                <span className="form-field">
                  <label htmlFor="lname">Artist/Band</label>
                  <input
                    type="text"
                    placeholder="Artist/Band"
                    value={artist}
                    onChange={(e) => setArtist(e.target.value)}
                  />
                </span>
                <br />

                <span className="form-field">
                  <label htmlFor="lname">Capo</label>
                  <input
                    type="text"
                    placeholder="Capo Number"
                    value={capo}
                    onChange={(e) => setCapo(e.target.value)}
                  />
                </span>
                <br />

                <span className="form-field">
                  <label htmlFor="lname">Chords</label>
                  <FroalaEditorComponent
                    config={{
                      height: 50,
                      toolbarInline: true,
                    }}
                    tag="textarea"
                    model={chords}
                    onModelChange={(event: any) => {
                      setChords(event);
                    }}
                  />
                </span>
                <br />
                <span className="form-field">
                  <label htmlFor="lname">Tags</label>
                  <TagInput
                    initialTags={tags}
                    onHandleUpdateTags={handleUpdateTags}
                  />
                </span>
                <br />
              </div>
              <div className="column-right">
                <span className="form-field">
                  <label htmlFor="lname">Song Type</label>
                  <input
                    type="text"
                    placeholder="Song Type"
                    value={songType}
                    onChange={(e) => setSongType(e.target.value)}
                  />
                </span>
                <br />

                <span className="form-field">
                  <label htmlFor="lname">Font Size</label>
                  <input
                    type="text"
                    placeholder="Font size"
                    value={defaultFontSize}
                    onChange={(e) => setDefaultFontSize(Number(e.target.value))}
                  />
                </span>
                <br />
                <span className="form-field">
                  <label htmlFor="folder">Folder</label>
                  <DropdownList
                    options={folderOptions}
                    selectedValue={folder}
                    onValueChanged={haandleFolderChanged}
                  />
                </span>
                <br />
              </div>
            </div>

            <FroalaEditorComponent
              config={{
                height: 800,
              }}
              tag="textarea"
              model={lyrics}
              onModelChange={(event: any) => {
                setLyrics(event);
              }}
            />

            <button type="submit" className="btn">
              <FontAwesomeIcon icon={faSave} /> Save
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditSongSheet;
